import { FormattedMessage } from 'react-intl';
import { ShipmentDetailsTable } from './ShipmentDetailsTable';
import { Vehicle } from '../../../../sharedComponents/common.types';
import Divider from '@rio-cloud/rio-uikit/Divider';
import { CustomsInformationTable } from './CustomsInformationTable';

type ShipmentDetailBodyProps = {
    readonly vehicle: Vehicle;
    readonly serviceKey: string | undefined;
    readonly generalInformation: string | undefined;
};

export const ShipmentDetailsExpanderBody = ({ vehicle, serviceKey, generalInformation }: ShipmentDetailBodyProps) => {
    return (
        <>
            <ShipmentDetailsTable vehicle={vehicle} serviceKey={serviceKey} displayServiceKey />

            <Divider dividerColor="lighter">
                <div className="tag tag-small">
                    <FormattedMessage id="outboundOrderBook.common.sidebar.details.vehicle.customsInformation" />
                </div>
            </Divider>

            <CustomsInformationTable customsInformation={vehicle.customsInformation} />

            <Divider dividerColor="lighter">
                <div className="tag tag-small">
                    <FormattedMessage id="outboundPortal.transportAssignments.sidebar.shipment.details.generalInformation" />
                </div>
            </Divider>

            {generalInformation ? (
                <div className="padding-10">{generalInformation}</div>
            ) : (
                <div className="padding-10 text-center text-color-gray">
                    <FormattedMessage id="outboundPortal.transportAssignments.sidebar.shipment.details.generalInformation.notSpecified" />
                </div>
            )}
        </>
    );
};
